
export const API_GATEWAY_BASE_URL = import.meta.env.VITE_HOST_API;
export const HRM_API_BASE_URL = import.meta.env.VITE_HRM_API ?? 'https://hrmback.mrnware.com/api';
export const HRM_APP_URL = import.meta.env.VITE_HRM_APP_URL ?? 'https://hrm.mrnware.com';
